import {
  styled,
  CircularProgress,
  Box,
} from '@mui/material';

interface TotalCostStyledProps {
  cartDrawerDetails: boolean;
}

export const TotalCostStyled = styled(Box)(
  ({ cartDrawerDetails }: TotalCostStyledProps) => ({
    width: '120px',
    height: '80px',
    '#cart-drawer-button': {
      div: {
        fontSize: '23px',
        lineHeight: '32px',
        color: '#000',
        textAlign: 'left',
      },
    },
    '@media (min-width: 744px)': {
      float: cartDrawerDetails ? 'none' : 'right',
      textAlign: cartDrawerDetails ? 'center' : 'right !important',
      borderLeft: cartDrawerDetails ? 0 : '1px solid #dee2e6',
    },
    '@media (max-width: 743px)': {
      float: cartDrawerDetails ? 'none' : 'left',
      textAlign: cartDrawerDetails ? 'center' : 'left !important',
    },
  })
);

export const TabletBGStyled = styled('div')({
  justifyContent: 'center',
  '@media (min-width: 744px) and (max-width: 1199px)': {
    backgroundColor: '#F6F8F9',
    boxShadow: 'inset rgba(0, 0, 0, 0.24) 0 7px 9px -7px',
    justifyContent: 'center',
    height: '80px',
  },
});

export const EnrollmentNavVisibleStyled = styled('nav')({
  '@media (max-width: 743px)': {
    display: 'none',
  },
  '@media (min-width: 744px) and (max-width: 1199px)': {
    position: 'relative',
    width: '100%',
  },
});

export const DrawerVisibleStyled = styled('div')({
  display: 'flex',
  flex: '0 0 72px',
  textAlign: 'right',
  '@media (min-width: 744px)': {
    display: 'none',
  },
});

export const TabletChatBotStyling = styled('div')({
  '@media (max-width: 743px)': {
    display: 'none',
  },
  '@media (min-width: 1200px)': {
    display: 'none',
  },
});

export const MobileStepperStyled = styled('div')({
  '@media (min-width: 744px)': {
    display: 'none',
  },
  marginTop: '100px',
  marginBottom: '-30px',
  marginLeft: 0,
  marginRight: 0,
  position: 'relative',
  top: 0,
});

export const StepLabel = styled('h2')({
  position: 'absolute',
  top: '11px',
  left: '42px',
  textAlign: 'center',
});

export const CircularProgressStyled = styled(CircularProgress)({
  marginLeft: '2.4rem',
  position: 'absolute',
  marginBottom: 0,
  left: 0,
});

export const BaseCircularProgressStyled = styled(CircularProgress)(
  ({ theme }) => ({
    marginLeft: '2.4rem',
    marginBottom: 0,
    color: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  })
);

export const HeaderPerPayPeriodBoxStyled = styled('div')({
  justifyContent: 'end',
  '@media (max-width: 743px)': {
    justifyContent: 'start',
    flexDirection: 'row-reverse',
  },
});
